class SayeScaledEmbed extends HTMLElement {
  connectedCallback() {
    this.iframe = this.querySelector('iframe');
    this.nativeWidth = parseInt(this.dataset.nativeWidth, 10) || 900;
    this.nativeHeight = parseInt(this.dataset.nativeHeight, 10) || 1200;

    if (this.iframe) {
      this.iframe.style.width = this.nativeWidth + 'px';
      this.iframe.style.height = this.nativeHeight + 'px';
      this.iframe.style.transformOrigin = 'top left';
    }

    this._resize = this._resize.bind(this);
    this._resizeObserver = new ResizeObserver(this._resize);
    this._resizeObserver.observe(this);
    this._resize();
  }

  _resize() {
    if (!this.iframe) return;
    const scale = this.clientWidth / this.nativeWidth;
    this.iframe.style.transform = `scale(${scale})`;
    this.style.height = Math.round(this.nativeHeight * scale) + 'px';
  }

  disconnectedCallback() {
    if (this._resizeObserver) this._resizeObserver.disconnect();
  }
}

customElements.define('saye-scaled-embed', SayeScaledEmbed);
